import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';

@Injectable()
export class UnAuthGuard {

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private router: Router,
  ) { }

  canActivate() {
    if (!isPlatformBrowser(this.platformId))
      return true;

    let userFromStorage = localStorage.getItem('currentUser') ? localStorage.getItem('currentUser') : null;

    if (userFromStorage != null) {
      this.router.navigate(['/manager']);
      return false;
    }

    return true;
  }
}
